











import { Component, Prop, Vue } from 'vue-property-decorator';
import AsideMenuItem from './AsideMenuItem.vue';

@Component({
  components: {
    AsideMenuItem,
  },
})
export default class AsideMenuList extends Vue {
  @Prop({
    default: false,
  })
  public isSubmenuList!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  })
  public menu!: any;

  public menuClick(item: any): void {
    this.$emit('menu-click', item);
  }
}
